module.exports = __webpack_public_path__ + "img/wechat.4d067c26.jpg";